import { SUBSCRIPTION_LEVELS } from '../../account/constants';
import timeClockIcon from '../../assets/svg/Icons/32/timesheet-gray.svg';
import laborCostIcon from '../../assets/svg/Icons/32/labor-gray.svg';
import reportsIcon from '../../assets/svg/Icons/32/reports-gray.svg';
import tagsIcon from '../../assets/svg/Icons/32/tag-gray.svg';
import scheduleTemplatesIcon from '../../assets/svg/Icons/32/shift-gray.svg';
import ptoIcon from '../../assets/svg/Icons/32/shift-leave-gray.svg';
import noShowIcon from '../../assets/svg/Icons/32/no-show-gray.svg';
import slotsIcon from '../../assets/svg/Icons/32/shift-available-gray.svg';
import googleSyncIcon from '../../assets/svg/Icons/32/calendarsync-gray.svg';
import businessClosedIcon from '../../assets/svg/Icons/32/business-closed-gray.svg';
import messagesIcon from '../../assets/svg/Icons/32/message-gray.svg';
import shiftTasksIcon from '../../assets/svg/Icons/32/task-gray.svg';

import otherFeaturesUrl from './otherPremiumFeaturesComponent.html';

const FEATURES = [
  { key: 'timeclock', title: 'Time clock', icon: timeClockIcon },
  { key: 'laborCost', title: 'Labor cost', icon: laborCostIcon },
  { key: 'reports', title: 'Reports', icon: reportsIcon },
  { key: 'tags', title: 'Tags', icon: tagsIcon },
  { key: 'scheduleTemplates', title: 'Schedule templates', icon: scheduleTemplatesIcon },
  { key: 'pto', title: 'PTO tracking', icon: ptoIcon },
  { key: 'slots', title: 'Slots on available shifts', icon: slotsIcon },
  { key: 'noShow', title: 'No show & sick callout tracking', icon: noShowIcon },
  { key: 'googleCalendarSync', title: 'Google Calendar synchronization', icon: googleSyncIcon },
  { key: 'businessClosed', title: 'Business closed', icon: businessClosedIcon },
  { key: 'kiosk', title: 'Kiosk time clock', icon: timeClockIcon },
  { key: 'messages', title: 'Messages', icon: messagesIcon },
  { key: 'unavailability', title: 'Unavailability', icon: scheduleTemplatesIcon },
  { key: 'shiftTasks', title: 'Shift tasks', icon: shiftTasksIcon },
];

class OtherPremiumFeaturesController {
  constructor(Authentication, AccountService) {
    'ngInject';

    Object.assign(this, { Authentication, AccountService });
  }

  $onInit() {
    const hiddenKeys = this.hiddenKeys || [];

    const level = this.isPremiumCurrentPlan
      ? SUBSCRIPTION_LEVELS.OLD_PREMIUM
      : SUBSCRIPTION_LEVELS.PREMIUM;
    this.otherPremiumFeaturesList = FEATURES.filter(
      ({ key }) =>
        !hiddenKeys.includes(key) &&
        this.Authentication.user.orgSettings.premiumFeatures[key] >= level
    );
  }

  get isPremiumCurrentPlan() {
    return (
      this.Authentication.user.org.isPremium &&
      !this.Authentication.user.org.isBusinessSubscription &&
      !this.Authentication.user.org.subscriptionCancelDate
    );
  }
}

export default {
  templateUrl: otherFeaturesUrl,
  controller: OtherPremiumFeaturesController,
  controllerAs: 'ctrl',
  bindings: {
    hiddenKeys: '<',
  },
};
